import { computed } from 'mobx';
import { constructKeytip, getKeytipString } from 'owa-command-ribbon';
import { getChangeNoteColorSections } from '../sections';
import { getControlInfo } from 'owa-mail-ribbon-utils';
import { getDefaultRibbonStyles } from 'owa-command-ribbon-styles/lib/util/getDefaultRibbonStyles';
import { MailRibbonControlId, MailRibbonTabId } from 'owa-ribbon-ids';
import { onDeleteNoteClicked, onViewEmailFromNoteClicked } from '../../util/commandActions';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { createMailAppButton, createMailAppFlyoutAnchor } from '../../util/createMailRibbonButton';

/**
 * This file is for shared components in read-only scenarios. Meaning, any tab or control that only shows up
 * when a user is composing. In this case, Home tab, View tab, and Notes tab are good examples.
 *
 * For controls that show up in compose-only scenarios, please use composeSharedControlDefinitions.ts.
 */

const computeDeleteNoteControl = computed(
    (): RibbonControlProps => {
        const controlInfo = getControlInfo(MailRibbonControlId.Notes_DeleteNote);
        return createMailAppButton(
            MailRibbonControlId.Notes_DeleteNote,
            controlInfo.text,
            controlInfo.tooltip,
            false /*isPopout*/,
            onDeleteNoteClicked,
            constructKeytip(
                [getKeytipString(MailRibbonTabId.Tab_Notes)],
                getKeytipString(MailRibbonControlId.Notes_DeleteNote)
            ),
            controlInfo.iconName,
            undefined /*iconColor*/,
            getDefaultRibbonStyles()
        );
    }
);
export const getDeleteNoteControl = () => computeDeleteNoteControl.get();

const computeChangeNoteColorControl = computed(
    (): RibbonControlProps => {
        const controlInfo = getControlInfo(MailRibbonControlId.Notes_ChangeColor);
        return createMailAppFlyoutAnchor(
            MailRibbonControlId.Notes_ChangeColor,
            controlInfo.text,
            controlInfo.tooltip,
            false /*isPopout*/,
            {
                sections: [
                    {
                        controls: getChangeNoteColorSections(),
                    },
                ],
            },
            constructKeytip(
                [getKeytipString(MailRibbonTabId.Tab_Notes)],
                getKeytipString(MailRibbonControlId.Notes_ChangeColor),
                true /* hasMenu */
            ),
            controlInfo.iconName,
            undefined /*iconColor*/,
            getDefaultRibbonStyles()
        );
    }
);
export const getChangeNoteColorControl = () => computeChangeNoteColorControl.get();

const computeNotesViewEmailControl = computed(
    (): RibbonControlProps => {
        const controlInfo = getControlInfo(MailRibbonControlId.Notes_ViewEmail);
        return createMailAppButton(
            MailRibbonControlId.Notes_ViewEmail,
            controlInfo.text,
            controlInfo.tooltip,
            false /*isPopout*/,
            onViewEmailFromNoteClicked,
            constructKeytip(
                [getKeytipString(MailRibbonTabId.Tab_Notes)],
                getKeytipString(MailRibbonControlId.Notes_ViewEmail)
            ),
            controlInfo.iconName,
            undefined /*iconColor*/,
            getDefaultRibbonStyles()
        );
    }
);
export const getNotesViewEmailControl = () => computeNotesViewEmailControl.get();
